/// <reference path="appConfig.d.ts" />
let customizationObject;

function getCustomizationObject() {
    if(!customizationObject) {
        customizationObject =  window.appConfig.customization || {};
    }
    return customizationObject;


}

export function getViewCss() {
    return getCustomizationObject().viewCss;
}

export function getResouceTypeImages() {
    return getCustomizationObject().resourceIcons;
}

export function getAdditionalLocationImages() {
    return getCustomizationObject().additionalLocationIcons;
}
export function getLibraryLogo() {
    return getCustomizationObject().libraryLogo;
}

export function getLibraryLogoClickableURL() {
    return getCustomizationObject().libraryLogoClickableURL;
}

export function getCentralCss() {
    return getCustomizationObject().centralCss;
}

export function getCentralJs() {
    return getCustomizationObject().centralJs;
}

export function getColorCss() {
    return getCustomizationObject().colorCss ;
}

export function getFavIcon() {
    return getCustomizationObject().favIcon;
}

export function getHomeScreenIcon() {
    return getCustomizationObject().homeScreenIcon;
}

export function getViewJs() {
    return getCustomizationObject().viewJs;
}

export function getViewSvg() {
    return getCustomizationObject().viewSvg;
}

export function getStaticHtml() {
    return getCustomizationObject().staticHtml;
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/appConfig/customizationConfig.ts